import { render } from "./PanelAdminArticleChange.vue?vue&type=template&id=1b6efc39&scoped=true&ts=true"
import script from "./PanelAdminArticleChange.vue?vue&type=script&lang=ts"
export * from "./PanelAdminArticleChange.vue?vue&type=script&lang=ts"

import "./PanelAdminArticleChange.vue?vue&type=style&index=0&id=1b6efc39&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6efc39"]])

export default __exports__